import service from '@/utils/request'

//左侧菜单

export function getRouters() {
	return service.request({
		method: 'get',
		url: '/app/permission/getRouters',
	})
}


